import { sendEmail } from "./send-email";

const demoRecipients = "sales@rossware.net;andrew.hutsch@fullsteam.com";

export async function submitDemoRequestForm({ to, from, first, last, phone, company }) {
  const emailBody =`Please schedule a demo for \nCompany: ${company}\n Name: ${first} ${last} \nPhone number: ${phone}`;
  const emailSubject = `${company} wants to schedule a demo`;
  return sendEmail({ to, from, subject: emailSubject, body: emailBody, body_is_html: true });
}

export async function submitContactForm({ to, from, subject, body }) {
  return sendEmail({ to, from, subject, body, body_is_html: true });
}

const demoFromAddress = "demo@mg.rossware.net";

export async function submitDemoEmail({ userEmail, first, last, company, phone, marketingOptIn }) {
  const subject = `${company || 'A company'} wants to schedule a demo`;
  const body = `Please schedule a demo for:
Name: ${first} ${last}
Company: ${company}
Email: ${userEmail}
Phone number: ${phone}
Marketing opt-in: ${marketingOptIn ? 'Yes' : 'No'}`;

  return sendEmail({
    to: demoRecipients,
    from: demoFromAddress,
    subject,
    body,
    body_is_html: true,
  });
}
